export default "__VITE_ASSET__D8nRnbE7__"